import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=3e0c9f14&scoped=true"
import script from "./shopDetail.vue?vue&type=script&lang=js"
export * from "./shopDetail.vue?vue&type=script&lang=js"
import style0 from "./shopDetail.vue?vue&type=style&index=0&id=3e0c9f14&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0c9f14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0c9f14')) {
      api.createRecord('3e0c9f14', component.options)
    } else {
      api.reload('3e0c9f14', component.options)
    }
    module.hot.accept("./shopDetail.vue?vue&type=template&id=3e0c9f14&scoped=true", function () {
      api.rerender('3e0c9f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/shopDetail.vue"
export default component.exports